export class CustomServerError extends Error {
    constructor(message, errorType) {
        super(message)

        this.errorType = errorType
    }
}
